import {LegalReportSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {lazy} from '@aboutyou/lazy-imports';
import {
  ContentPopperProps,
  GenericIconName,
  Icon,
  Text,
  UnstyledButton,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {ComponentProps, useEffect, useRef} from 'react';
import {useLegalReportStateManager} from './utils/useLegalReportStateManager';

export const LegalReportPopupFlyout = lazy(() =>
  import('./LegalReportPopup').then(mod => ({
    default: mod.LegalReportPopup,
  })),
);

interface LegalReportViewProps extends LegalReportSection {
  className?: string;
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const LegalReportView: React.FC<LegalReportViewProps> = ({
  className,
  ContentPopperLayoutComponent,
  cta,
  popup,
}) => {
  const {open} = useLegalReportStateManager();

  if (!cta) {
    return null;
  }

  return (
    <>
      <Wrapper
        data-testid="legalReport"
        className={className}
        onClick={() => open()}
        aria-label={undefined}
      >
        <Icon asset={GenericIconName.FlagReport} size="SS" />
        <StyledText weight="mediumHeavy">{cta}</StyledText>
      </Wrapper>
      <LegalReportPopup
        {...popup}
        ContentPopperLayoutComponent={ContentPopperLayoutComponent}
      />
    </>
  );
};

const LegalReportPopup: React.FC<
  ComponentProps<typeof LegalReportPopupFlyout>
> = props => {
  const openedOnce = useRef(false);
  const {isOpen} = useLegalReportStateManager();

  useEffect(() => {
    if (isOpen) {
      openedOnce.current = true;
    }
  }, [isOpen]);

  if (!openedOnce.current) {
    return null;
  }

  return <LegalReportPopupFlyout {...props} />;
};

const Wrapper = styled(UnstyledButton)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledText = styled(Text)`
  text-decoration: underline;
`;
